import Layout from '../components/Layout';
import { useEffect, useState } from 'react';
import { getAccount, getAllAccount, revokeAdmin, getSchedule, deleteSchedule, editActivity, addSegnalazioni, updateAdminRole, deleteAccount } from '../supabase';
import { useNavigate } from 'react-router-dom';
import AdminForm from './AdminForm';
import Profilo from '../profilo';

function Admin() {
    const navigation = useNavigate()
    const [openModalAndSetId, setOpenModalAndSetId] = useState({ open: false, id: '' })
    const [admin, setAdmin] = useState(false)
    const [editMode, setEditMode] = useState(false);
    const [currentActivity, setCurrentActivity] = useState(null);
    
    // Add state for segnalazione modal
    const [segnalazioneModal, setSegnalazioneModal] = useState({
        open: false,
        userId: '',
        userName: ''
    });
    const [segnalazioneText, setSegnalazioneText] = useState('');

    const [now, setNow] = useState(0) // 0: Gestione giocata, 1: Gestione utenti, 2: Gestione partite

    const [schedule, setSchedule] = useState([])

    const getSchedules = async () => {
        const data = await getSchedule()
        const sortByCreated = data.sort((a, b) => b.id - a.id)
        setSchedule(sortByCreated)
    }

    const deleteSchedules = async (id) => {
        await deleteSchedule(id)
        getSchedules()
    }

    const [users, setUsers] = useState([])

    const getUsers = async () => {
        const data = await getAllAccount()
        const sortByCreated = data.sort((a, b) => b.id - a.id)
        setUsers(sortByCreated)
    }

    const checkIFAdmin = async () => {
        const mail = localStorage.getItem('mail')
        const account = await getAccount(mail)
        if (account[0].admin) {
            setAdmin(true)
        }
        else {
            setAdmin(false)
            navigation('/home')
        }
    }

    const revoke = async (id, state) => {
        await revokeAdmin(id, state)
        getUsers()
    }

    const toggleAdminRole = async (mail, currentAdmin) => {
        await updateAdminRole(mail, !currentAdmin)
        getUsers()
    }

    const deleteUser = async (mail, name) => {
        const selfMail = localStorage.getItem('mail')
        if (mail === selfMail) {
            alert('Non puoi eliminare il tuo stesso account')
            return
        }
        const confirmDelete = window.confirm(`Sei sicuro di voler eliminare l'account di ${name}?`)
        if (!confirmDelete) {
            return
        }
        await deleteAccount(mail)
        getUsers()
    }

    useEffect(() => {
        checkIFAdmin()
        getUsers()
        getSchedules()
    }, [])

    const handleSegnalazioneSubmit = async () => {
        if (!segnalazioneText.trim()) {
            alert('Inserisci un testo per la segnalazione');
            return;
        }
        
        try {
            await addSegnalazioni(segnalazioneModal.userId, segnalazioneText ,segnalazioneModal.userName);
            alert('Segnalazione aggiunta con successo');
            setSegnalazioneModal({ open: false, userId: '', userName: '' });
            setSegnalazioneText('');
        } catch (error) {
            console.error('Error adding segnalazione:', error);
            alert('Errore durante l\'aggiunta della segnalazione');
        }
    };

    const activeOrInactive = (e) => {
        if (e === true) {
            return 'bg-black text-white p-5 rounded-xl font-bold'
        }
        else {
            return 'bg-[#1A1919] text-[#87858560] p-5 rounded-xl font-bold'
        }
    }

    // Update this function to handle three states
    const getActiveClass = (tabIndex) => {
        return now === tabIndex
            ? 'bg-black text-white p-5 rounded-xl font-bold text-sm'
            : 'bg-[#1A1919] text-[#878585] p-5 rounded-xl font-bold text-sm';
    }

    const UIUtenti = () => {
        return (
            <ul role="list" className="pb-36 w-full">
                {users.map((person) => (
                    <li key={person.id} className="bg-[#1E2021] w-full h-fit flex flex-col rounded-3xl p-4 mb-4">
                        
                        <div className="flex min-w-0 gap-x-4">
                            <div className="min-w-0 flex-auto">
                                <p className="text-sm font-semibold leading-6 text-white">{person.nome}</p>
                                <p className="mt-1 truncate text-xs leading-5 text-gray-400">{person.mail}</p>
                            </div>
                        </div>

                        <div className='w-full flex flex-row justify-between pt-6'>
                            {person.accepted === false || person.accepted === null ?
                                <div className="shrink-0 sm:flex sm:flex-col sm:items-end" onClick={() => revoke(person.mail, !person.accepted)}>
                                    <button className='text-[#839262] border border-[#839262] font-bold py-2 px-4 rounded-full w-full'>Accetta</button>
                                </div> :
                                <div className="shrink-0 sm:flex sm:flex-col sm:items-end" onClick={() => revoke(person.mail, !person.accepted)}>
                                    <button className='text-[#839262] border border-[#839262] font-bold py-2 px-4 rounded-full w-full'>Blocca</button>
                                </div>
                            }
                            {/* <div className="shrink-0 sm:flex sm:flex-col sm:items-end">
                                <button
                                    className='text-[#839262] border border-[#839262] font-bold py-2 px-4 rounded-full w-full'
                                    onClick={() => setSegnalazioneModal({
                                        open: true,
                                        userId: person.id,
                                        userName: person.nome
                                    })}
                                >
                                    Aggiungi segnalazione
                                </button>
                            </div> */}
                            {localStorage.getItem('mail') !== person.mail && (
                                <>
                                    <div className="shrink-0 sm:flex sm:flex-col sm:items-end">
                                        <button
                                            className='text-[#839262] border border-[#839262] font-bold py-2 px-4 rounded-full w-full'
                                            onClick={() => toggleAdminRole(person.mail, person.admin)}
                                        >
                                            {person.admin ? 'Rimuovi admin' : 'Rendi admin'}
                                        </button>
                                    </div>
                                    <div className="shrink-0 sm:flex sm:flex-col sm:items-end ml-2">
                                        <button
                                            className='text-red-500 border border-red-500 font-bold py-2 px-4 rounded-full w-full'
                                            onClick={() => deleteUser(person.mail, person.nome)}
                                        >
                                            Elimina
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                        {/* <div className="shrink-0 sm:flex sm:flex-col sm:items-end" onClick={() => setOpenModalAndSetId({open: true, id: person.mail })}>
                            <button className='text-[#839262] border border-[#839262] font-bold py-2 px-4 rounded-full w-full'>Info utente</button>
                        </div>*/}
                    </li>
                ))}
            </ul>
        )
    }



    const UIschedule = () => {
        return (
            <div className='w-full pb-36 bg-bg-lg pt-8'>
                <div className='flex flex-col w-full'>
                    <div className='flex flex-row justify-between items-center'>
                        <h1 className='text-white font-bold text-2xl'>Gestione giocata</h1>

                    </div>
                    <div className='flex flex-col w-full'>
                        {schedule.map(s => {
                            return (
                                <div className='flex flex-row justify-between items-center bg-[#1A1919] p-4 rounded-lg mt-4' key={s.id}>
                                    <div className='flex flex-col'>
                                        <h1 className='text-white font-bold text-xl'>{s.title}</h1>
                                        <p className='text-white text-sm'>{s.date}</p>
                                    </div>
                                    <div className='flex flex-col'>
                                        <button className='bg-[#839262] text-white px-4 py-2 rounded-lg font-bold' onClick={() => deleteSchedules(s.id)}>Elimina</button>
                                        <button className='bg-[#839262] text-white px-4 py-2 rounded-lg font-bold mt-2'
                                            onClick={() => {
                                                setCurrentActivity(s);
                                                setEditMode(true);
                                                setNow(0);
                                            }}>Modifica</button>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }


    const openProfiloUtente = (id) => {
        <Profilo id={id} />
    }






    return (
        <Layout>
            <div className='flex w-full h-full flex-col overflow-scroll'>

                <div className='flex flex-1'>

                    <div className='flex flex-1 flex-col items-start '>
                        <div className='flex flex-row justify-start items-start mb-4'>
                            <button onClick={() => {
                                setNow(0);
                                setEditMode(false);
                                setCurrentActivity(null);
                            }} className={getActiveClass(0)}>
                                {editMode ? 'Modifica giocata' : 'Creazione giocata'}
                            </button>
                            <button onClick={() => setNow(1)} className={getActiveClass(1)} style={{ marginLeft: '12px' }}>Gestione utenti</button>
                            <button onClick={() => setNow(2)} className={getActiveClass(2)} style={{ marginLeft: '12px' }}>Gestione partite</button>
                        </div>

                        {now === 1 ? <UIUtenti /> :
                            now === 0 ? <AdminForm admin={admin} editMode={editMode} activity={currentActivity} getSchedules={getSchedules} /> :
                                now === 2 ?
                                    <UIschedule />
                                    : null}

                        {openModalAndSetId.open ?
                            <div className='fixed top-0 left-0'>
                                <Profilo id={openModalAndSetId.id} setClose={setOpenModalAndSetId} />
                            </div>
                            : null}

                        {/* Add Segnalazione Modal */}
                        {segnalazioneModal.open && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                <div className="bg-[#1E2021] p-6 rounded-xl max-w-md w-full mx-4">
                                    <h3 className="text-white text-lg font-bold mb-4">
                                        Aggiungi segnalazione per {segnalazioneModal.userName}
                                    </h3>
                                    <textarea
                                        className="w-full bg-[#1A1919] text-white border border-[#839262] rounded-lg p-3 min-h-[150px] mb-4"
                                        placeholder="Inserisci il testo della segnalazione..."
                                        value={segnalazioneText}
                                        onChange={(e) => setSegnalazioneText(e.target.value)}
                                    ></textarea>
                                    <div className="flex justify-end space-x-4">
                                        <button
                                            className="px-4 py-2 text-white hover:text-gray-300"
                                            onClick={() => {
                                                setSegnalazioneModal({ open: false, userId: '', userName: '' });
                                                setSegnalazioneText('');
                                            }}
                                        >
                                            Annulla
                                        </button>
                                        <button
                                            className="px-4 py-2 bg-[#839262] text-white rounded hover:bg-opacity-80"
                                            onClick={handleSegnalazioneSubmit}
                                        >
                                            Conferma
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default Admin;

 
